import { useQuery } from "@tanstack/react-query"

import { useApiContext } from "@/hooks/api/use-api-context"

import { fetchSyncboxEmailDraft, fetchSyncboxEmailDrafts, SyncboxEmailDraftOwner } from "./api"

export function useSyncboxEmailDrafts(owner: SyncboxEmailDraftOwner) {
  const getContext = useApiContext()
  const ownerType = owner.householdId ? "household" : owner.contactId ? "contact" : "business"
  const ownerId = owner.householdId ?? owner.contactId ?? owner.businessId

  return useQuery({
    queryKey: ["syncbox_email_drafts", ownerType, ownerId],
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No context found")
      return fetchSyncboxEmailDrafts(context, owner)
    },
    select: (data) => data.email_drafts,
    enabled: !!ownerId,
  })
}

export function useSyncboxEmailDraft(id: string, options?: { enabled?: boolean }) {
  const getContext = useApiContext()
  const enabled = options?.enabled ?? true

  return useQuery({
    queryKey: ["syncbox_email_draft", id],
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No context found")
      return fetchSyncboxEmailDraft(context, id)
    },
    enabled: !!id && enabled,
  })
}
